import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '@/views/HomeView.vue'
import LoginView from '@/views/auth/LoginView.vue'
import RegisterView from '@/views/auth/RegisterView.vue'
import ForgotPasswordView from '@/views/auth/ForgotPasswordView.vue'
import CreateJobView from '@/views/jobs/CreateJobView.vue'
import JobDetailView from '@/views/jobs/JobDetailView.vue'
import EditJobView from '@/views/jobs/EditJobView.vue'
import MypageLayout from '@/views/mypage/MypageLayout.vue'
import MyBookmarksView from '@/views/mypage/MyBookmarksView.vue'
import MyJobsView from '@/views/mypage/MyJobsView.vue'
import MyProfileView from '@/views/mypage/MyProfileView.vue'
import AdminLayout from '@/views/admin/AdminLayout.vue'
import AdminDashboardView from '@/views/admin/AdminDashboardView.vue'
import AdminBannersView from '@/views/admin/AdminBannersView.vue'
import AdminTopBannerView from '@/views/admin/AdminTopBannerView.vue'
import AdminJobsView from '@/views/admin/AdminJobsView.vue'
import AdminUsersView from '@/views/admin/AdminUsersView.vue'
import SearchView from '@/views/SearchView.vue'
import { auth } from '@/services/firebase'
import { onAuthStateChanged } from 'firebase/auth'
import PartnersView from '@/views/partners/PartnersView.vue'
import ContactView from '@/views/ContactView.vue'
import AIView from '@/views/AIView.vue'
import MapView from '@/views/MapView.vue'
import RegionsView from '@/views/RegionsView.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomeView
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginView
  },
  {
    path: '/register',
    name: 'Register',
    component: RegisterView
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPasswordView
  },
  {
    path: '/jobs/create',
    name: 'CreateJob',
    component: CreateJobView,
    meta: { requiresAuth: true }
  },
  {
    path: '/jobs/:id',
    name: 'JobDetail',
    component: JobDetailView
  },
  {
    path: '/jobs/:id/edit',
    name: 'EditJob',
    component: EditJobView,
    meta: { requiresAuth: true }
  },
  {
    path: '/search',
    name: 'Search',
    component: SearchView,
    meta: { title: '공고 검색' }
  },
  {
    path: '/partners',
    name: 'Partners',
    component: PartnersView,
    meta: { title: '공고 검색' }
  },
  {
    path: '/contact',
    name: 'Contact',
    component: ContactView,
  },
  {
    path: '/ai-chat',
    name: 'AIChat',
    component: AIView,
  },
  {
    path: '/map',
    name: 'MapView',
    component: MapView,
  },
  {
    path: '/regions',
    name: 'Regions',
    component: RegionsView,
  },
  // 사이드 라우트
  {
    path: '/sides',
    name: 'Sides',
    component: () => import('@/views/sides/SidesView.vue'),
    meta: { title: '사이드' }
  },
  {
    path: '/sides/create',
    name: 'CreateSide',
    component: () => import('@/views/sides/CreateSideView.vue'),
    meta: { requiresAuth: true, title: '사이드 글쓰기' }
  },
  {
    path: '/sides/:id',
    name: 'SideDetail',
    component: () => import('@/views/sides/SideDetailView.vue'),
    meta: { title: '사이드 상세' }
  },
  {
    path: '/sides/:id/edit',
    name: 'EditSide',
    component: () => import('@/views/sides/EditSideView.vue'),
    meta: { requiresAuth: true, title: '사이드 수정' }
  },
  // 이벤트 라우트
  {
    path: '/events',
    name: 'Events',
    component: () => import('@/views/event/EventsView.vue'),
    meta: { title: '이벤트' }
  },
  {
    path: '/events/:id',
    name: 'EventDetail',
    component: () => import('@/views/event/EventDetailView.vue'),
    meta: { title: '이벤트 상세' }
  },
  // 공지사항 라우트
  {
    path: '/notices',
    name: 'Notices',
    component: () => import('@/views/notice/NoticesView.vue'),
    meta: { title: '공지사항' }
  },
  {
    path: '/notices/:id',
    name: 'NoticeDetail',
    component: () => import('@/views/notice/NoticeDetailView.vue'),
    meta: { title: '공지사항 상세' }
  },
  // 1:1 문의 라우트
  {
    path: '/inquiry',
    name: 'InquiryCreate',
    component: () => import('@/views/inquiry/InquiryCreateView.vue'),
    meta: { title: '1:1 문의' }
  },
  {
    path: '/faq',
    name: 'FAQ',
    component: () => import('@/views/FAQView.vue'),
    meta: { title: '자주 묻는 질문' }
  },
  {
    path: '/products',
    name: 'Pricing',
    component: () => import('@/views/PricingView.vue'),
    meta: { title: '상품 안내' }
  },
  {
    path: '/mypage',
    component: MypageLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        redirect: '/mypage/favorites'
      },
      {
        path: 'favorites',
        name: 'MyFavorites',
        component: MyBookmarksView
      },
      {
        path: 'jobs',
        name: 'MyJobs',
        component: MyJobsView
      },
      {
        path: 'profile',
        name: 'MyProfile',
        component: MyProfileView
      },
      {
        path: 'points',
        name: 'MyPoints',
        component: () => import('@/views/mypage/MyPointsView.vue')
      },
      {
        path: 'store',
        name: 'Store',
        component: () => import('@/views/mypage/MyStoreView.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'sides',
        name: 'MySides',
        component: () => import('@/views/mypage/MySidesView.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: '/mypage/event',
        name: 'MypageEvent',
        component: () => import('@/views/mypage/MypageEventView.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'inquiries',
        name: 'MyInquiries',
        component: () => import('@/views/mypage/MyInquiriesView.vue'),
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    path: '/admin',
    component: AdminLayout,
    meta: { requiresAuth: true, requiresAdmin: true },
    children: [
      {
        path: '',
        name: 'AdminDashboard',
        component: AdminDashboardView
      },
      {
        path: 'banners',
        name: 'AdminBanners',
        component: AdminBannersView
      },
      {
        path: 'top-banner',
        name: 'AdminTopBanner',
        component: AdminTopBannerView
      },
      {
        path: 'jobs',
        name: 'AdminJobs',
        component: AdminJobsView
      },
      {
        path: 'users',
        name: 'AdminUsers',
        component: AdminUsersView
      },
      {
        path: 'subbanner',
        name: 'AdminSubBanner',
        component: () => import('@/views/admin/AdminSubBanner.vue')
      },
      {
        path: 'settings',
        name: 'AdminSettings',
        component: () => import('@/views/admin/AdminSettingsView.vue')
      },
      {
        path: 'sidebarad',
        name: 'AdminSidebarAD',
        component: () => import('@/views/admin/AdminSidebarAdView.vue')
      },
      {
        path: 'partners',
        name: 'AdminPartners',
        component: () => import('@/views/admin/AdminPartnersView.vue')
      },
      {
        path: 'contact',
        name: 'AdminContact',
        component: () => import('@/views/admin/AdminContactView.vue')
      },
      {
        path: 'point-settings',
        name: 'AdminPointSettings',
        component: () => import('@/views/admin/AdminPointSettingsView.vue')
      },
      {
        path: 'products',
        name: 'AdminProducts',
        component: () => import('@/views/admin/AdminProductsView.vue'),
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        path: 'sides',
        name: 'AdminSides',
        component: () => import('@/views/admin/AdminSidesView.vue'),
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        path: 'events',
        name: 'AdminEvents',
        component: () => import('@/views/admin/AdminEventsView.vue'),
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        path: 'notices',
        name: 'AdminNotices',
        component: () => import('@/views/admin/AdminNoticesView.vue'),
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        path: 'inquiries',
        name: 'AdminInquiries',
        component: () => import('@/views/admin/AdminInquiriesView.vue'),
        meta: { requiresAuth: true, requiresAdmin: true }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

// 인증 상태 확인 함수
const getCurrentUser = () => {
  return new Promise((resolve, reject) => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      unsubscribe()
      resolve(user)
    }, reject)
  })
}

// 인증 가드
router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const requiresAdmin = to.matched.some(record => record.meta.requiresAdmin)
  
  if (requiresAuth) {
    const currentUser = await getCurrentUser()
    if (!currentUser) {
      next('/login')
      return
    }
    
    if (requiresAdmin) {
      const { doc, getDoc } = await import('firebase/firestore')
      const { db } = await import('@/services/firebase')
      const userDoc = await getDoc(doc(db, 'users', currentUser.uid))
      
      if (!userDoc.exists() || userDoc.data().role !== 'admin') {
        next('/')
        return
      }
    }
  }
  
  next()
})

export default router